import { render } from "./AppHeader.vue?vue&type=template&id=3b6538c4&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=3b6538c4&scoped=true&lang=css"

import exportComponent from "/home/harry/Desktop/Vue JS/Matrix Digital/Alearif zain portal/alearif-zain/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6538c4"]])

export default __exports__